"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AirDateSegment = _interopRequireDefault(require("./AirDateSegment"));
var _ImageCard = _interopRequireDefault(require("../../block/ImageCard"));
var _StringList = _interopRequireDefault(require("../../utils/StringList"));
var _Concat = _interopRequireDefault(require("../../utils/Concat"));
var _helpers = require("../../../utils/helpers");
function MovieItem(_ref) {
  var _scheduleItem$content, _scheduleItem$content2;
  let {
    scheduleItem,
    styles,
    handleClicks,
    strListArr,
    determineCTA
  } = _ref;
  const imageCardContentList = ["<div>".concat(scheduleItem.program_synopsis, "</div>"), /*#__PURE__*/_react.default.createElement(_StringList.default, {
    list: strListArr,
    separatorType: "pipe"
  })];
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _helpers.classes)([styles['schedule-list__item'], 'schedule-list__item']),
    key: "schedule-list-".concat(scheduleItem.id)
  }, /*#__PURE__*/_react.default.createElement(_AirDateSegment.default, {
    scheduleItem: scheduleItem,
    styles: styles
  }), /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
    id: scheduleItem.id,
    image: {
      url: (_scheduleItem$content = scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content2 = scheduleItem.content) === null || _scheduleItem$content2 === void 0 ? void 0 : _scheduleItem$content2.image) !== null && _scheduleItem$content !== void 0 ? _scheduleItem$content : '',
      altText: "",
      aspectRatio: 543 / 305
    },
    title: scheduleItem.program,
    content: /*#__PURE__*/_react.default.createElement(_Concat.default, {
      list: imageCardContentList
    }),
    cta: determineCTA(scheduleItem),
    clampContentLines: true,
    numberOfLinesToClamp: 5,
    displayInline: true,
    handleClicks: handleClicks
  }));
}
var _default = exports.default = MovieItem;